import * as actionType from 'ActionTypes';

export const setFilterData = (data) => {
	return {
		type: actionType.SET_FILTER_DATA,
		data
	};
};

export const setSelectedFilter = (filters) => {
	return {
		type: actionType.SET_SELECTED_FILTER,
		filters
	};
};

export const setIsSectionType = (isSection) => {
	return {
		type: actionType.SET_IS_SECTION_TYPE,
		isSection
	};
};

export const setIsVerifyType = (isVerify) => {
	return {
		type: actionType.SET_IS_VERIFY_TYPE,
		isVerify
	};
};

// export const setHasVideo = (hasVideo) => {
// 	return {
// 		type: actionType.SET_HAS_VIDEO,
// 		hasVideo
// 	};
// };

// export const setHasImage = (hasImage) => {
// 	return {
// 		type: actionType.SET_HAS_IMAGE,
// 		hasImage
// 	};
// };

// export const setHasAudio = (hasAudio) => {
// 	return {
// 		type: actionType.SET_HAS_AUDIO,
// 		hasAudio
// 	};
// };

export const setHasFiles = (hasFiles) => {
	return {
		type: actionType.SET_HAS_FILES,
		hasFiles
	};
};

export const setCategory = (categories) => {
	return {
		type: actionType.SET_CATEGORY,
		categories
	};
};

export const setSelectedCategory = (categories) => {
	return {
		type: actionType.SET_SELECTED_CATEGORY,
		categories
	};
};

export const setHasFilter = (status) => {
	return {
		type: actionType.SET_HAS_FILTER,
		status
	};
};

export const resetFilters = () => {
	return {
		type: actionType.RESET_FILTERS,
	};
};
